import { cookie } from '@pdrj/pmi-iqos-shared-react'
import { getPaginationParams } from '@iqosphere-common/utils'

export default class IqosphereProfile {
  constructor(api) {
    this.api = api
  }

  getMembershipCardQrImage = async () => {
    return await this.api.get('/iqosphere/qr', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getMembershipCardQrImage')
    })
  }

  getQoinsActions = async () => {
    return await this.api.get('/iqosphere/qoins/earning', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQoinsActions')
    })
  }

  getQoinsExpiring = async () => {
    return await this.api.get('/iqosphere/qoins/expiring', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getQoinsExpiring')
    })
  }

  getQoinsHistory = async (
    historyPaginationIndex = 0,
    historyPageSize = 10,
    type = 'all'
  ) => {
    return await this.api.get(
      '/iqosphere/qoins/history?type=' +
        type +
        getPaginationParams(historyPaginationIndex, historyPageSize),
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getQoinsHistory')
      }
    )
  }

  getProfile = async () => {
    return await this.api.get('/profile', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getProfile')
    })
  }

  setProfile = async () => {
    return await this.api.post('/profile', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      data: {},
      mock: this.api.getMock('setProfile')
    })
  }

  getNotices = async (pageIndex, pageSize) => {
    return await this.api.get(
      '/iqosphere/notices' + getPaginationParams(pageIndex, pageSize, true),
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getNotices')
      }
    )
  }

  updateNotice = async id => {
    return await this.api.post('/iqosphere/notices?rpc=true', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        noticeId: id
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('getNotices')
    })
  }

  getPrizes = async () => {
    return await this.api.get('/iqosphere/prizes/profile', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getProfilePrizes')
    })
  }

  getPrizesBarcode = async () => {
    return await this.api.get('/iqosphere/prizes/qrcode', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      mock: this.api.getMock('getPrizesBarcode')
    })
  }

  updateAvatarProfile = async ({ avatar, accessory }) => {
    return await this.api.post('/iqosphere/profile/avatar', {
      headers: {
        'Content-type': 'application/json',
        ...cookie.authorizationTokenHeader()
      },
      data: {
        avatar,
        accessory
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('updateAvatarProfile')
    })
  }

  getAvatarProfile = async () => {
    return await this.api.get('/iqosphere/profile/avatar', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('avatarProfile')
    })
  }

  getAvatarAccessories = async () => {
    return await this.api.get('/iqosphere/profile/accessories', {
      headers: {
        ...cookie.authorizationTokenHeader()
      },
      useProxy: true,
      withCredentials: true,
      mock: this.api.getMock('avatarAccessories')
    })
  }
}
